import requests from '@/utils/request.js'
import { callDynamicAPI } from '@/utils/dynamicApi.js'

// 使用动态API配置替代硬编码URL
export const getHeaderTabMenu = () => callDynamicAPI('tabs', 'headerMenu')
export const getAsideTabMenu = (pid) => callDynamicAPI('tabs', 'asideMenu', { pid })